// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2863":"c74a26e4","3832":"f3bdf5bc","4930":"f3bdf5bc","5232":"96f84291","7161":"c2fb2b34","7948":"f3bdf5bc","8014":"f3bdf5bc"}[chunkId] + ".chunk.css";
};